export default "__VITE_ASSET__o6NSCVY4__"